import axios from 'axios';
const global = require('./global');
import { Toast } from 'vant';
import Cryptojs from 'crypto-js'


const service = axios.create({
  // process.env.NODE_ENV === 'development' 来判断是否开发环境
  baseURL: process.env.NODE_ENV === 'development' ? global.baseUrl : global.baseUrl,
  timeout: 60000000
});

function getRadomNum(capacity) {
  let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  let res = "";
  for (let i = 0; i < capacity; i++) {
    var id = Math.ceil(Math.random() * chars.length);
    res += chars[id];
  }
  return res;
}

service.interceptors.request.use( config => {
  const nonceStr = getRadomNum(10);//随机字符串
  const appId = global.appId;//appId
  const appsecret = global.appsecret;//appsecret
  const timestamp = new Date().getTime();//时间戳
  let data = timestamp+appId+nonceStr;
  const sign = Cryptojs.HmacSHA256(data,appsecret).toString(); //要加密的密码
  config.headers['token'] = global.token;
  config.headers['timestamp'] = timestamp;
  config.headers['sign'] = sign;
  config.headers['appId'] = appId;
  config.headers['nonceStr'] = nonceStr;
  return config;
}, error => {
  return Promise.reject();
});

service.interceptors.response.use(response => {
  if(response.status === 200){
    if(response.data.status == 1){
      return response.data;
    }else{
      Toast(response.data.message);
      return  Promise.reject();
    }
  }else{
    return Promise.reject();
  }
}, error => {

  Toast('请求失败');
  return Promise.reject(error);
});

export default service;
